import { IconLockLarge, colors, size, spacing } from "@izettle/otto"
import { useLocalization } from "@izettle/tenko-react"

import { Content, Title2, RegularText, Anchor, SvgIcon } from "@/core/components/shared"
import {
  PaypalPrivacyPortalLink,
  PaypalPrivacyStatementLink,
} from "@/core/utils/constant"

type Props = {
  orgName: string
  phone?: string
  email?: string
  linkToMerchantPrivacyPolicy?: string
  targetLinks?: string
}

export function PolicyContent({
  orgName,
  phone,
  email,
  linkToMerchantPrivacyPolicy,
  targetLinks,
}: Props) {
  const { text } = useLocalization()
  return (
    <Content hasScroll withMoreFooterSpace>
      <div>
        <SvgIcon
          html={IconLockLarge.svg}
          padding={size.small}
          backgroundColor={colors.background.highlight}
        />
      </div>
      <Title2>
        {text("SIGNUP_PRIVACY_POLICY_HOW_THE_SELLER_HANDLES_YOUR_INFORMATION_TITLE")}
      </Title2>
      <RegularText>
        {text("SIGNUP_PRIVACY_POLICY_HOW_THE_SELLER_HANDLES_YOUR_INFORMATION_DESC")}
      </RegularText>

      <RegularText>
        {text("SIGNUP_IF_YOU_HAVE_MORE_QUESTIONS_PLEASE_REACH_OUT_TO_THE_SELLER", [
          linkToMerchantPrivacyPolicy && <span>{text("SIGNUP_OR_READ")}</span>,
          linkToMerchantPrivacyPolicy && (
            <Anchor href={linkToMerchantPrivacyPolicy} target={targetLinks}>
              {text("SIGNUP_MERCHANT_PRIVACY_POLICY", [orgName])}
            </Anchor>
          ),
        ])}
      </RegularText>

      <Title2>
        {text("SIGNUP_PRIVACY_POLICY_HOW_TO_BE_REMOVED_FROM_THE_CUSTOMER_LIST_TITLE")}
      </Title2>
      <RegularText>
        {text("SIGNUP_PRIVACY_POLICY_HOW_TO_BE_REMOVED_FROM_THE_CUSTOMER_LIST_DESC")}
      </RegularText>

      <Title2>{text("SIGNUP_HOW_PAYPAL_MANAGE_YOUR_INFO_TITLE")}</Title2>
      <RegularText>
        {text("SIGNUP_HOW_PAYPAL_MANAGE_YOUR_INFO_DESC", [
          <Anchor
            href={PaypalPrivacyPortalLink}
            target={targetLinks}
            key="paypalPrivacyPortalLink"
          >
            {text("SIGNUP_PRIVACY_POLICY_PAYPAL_PRIVACY_PORTAL")}
          </Anchor>,
        ])}
      </RegularText>

      <Title2>
        {text("SIGNUP_PRIVACY_POLICY_HOW_PAYPAL_HANDLES_YOUR_INFORMATION_TITLE")}
      </Title2>
      <RegularText>
        {text("SIGNUP_PRIVACY_POLICY_HOW_PAYPAL_HANDLES_YOUR_INFORMATION_DESC", [
          <Anchor
            href={PaypalPrivacyStatementLink}
            target={targetLinks}
            key="paypalPrivacyStatementLink"
          >
            {text("SIGNUP_PRIVACY_POLICY_PAYPAL_PRIVACY_STATEMENT")}
          </Anchor>,
        ])}
      </RegularText>

      <RegularText style={{ marginTop: spacing.large }}>
        {orgName} {orgName && <br />}
        {phone} {phone && <br />}
        {email} {email && <br />}
      </RegularText>

      {/* extra padding needed for some mobile browsers */}
      <div style={{ height: 120 }} />
    </Content>
  )
}
